import http from 'hub-http/clients/apiClient';
import { captureException } from 'raven-js';
const MINIFIED_SEARCH_PATH = `/search-minified/v1`;
let hasWarmedUp = false;

/**
 * To improve BE latency we're firing a standalone POST request to the search API
 * to warmup permission caches prior to the search API requeset.
 */
export const warmupSearchCache = () => {
  if (hasWarmedUp) return Promise.resolve(true);
  return http.post(`${MINIFIED_SEARCH_PATH}/search/warm-user-caches`, {
    timeout: 2000
  }).then(() => hasWarmedUp = true).catch(_error => {
    captureException(_error);
    return false;
  });
};